import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import TenantPage from 'components/common/TenantPage';
import { maintenanceService } from 'services/api';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import { GridColDef } from '@mui/x-data-grid-premium';
import { MaintenanceColumns } from 'components/common/enhanced/common-headers';
import toast from 'features/toast';

export const ArchivedMaintenances = () => {
  const translationPrefix = 'pages.maintenance-archive';

  const handleDelete = (id: number) => {
    maintenanceService.delete(id).then(() => {
      toast.success(t('actions.successfully.deleted'));
      datagridRefresh.current();
    });
  };

  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const columns: GridColDef[] = MaintenanceColumns(null, true, true, false, handleDelete);

  return (
    <>
      <TenantPage
        title={t(`${translationPrefix}.title`)}
        subtitle={t(`${translationPrefix}.subtitle`)}>
        <EnhancedDataGrid
          columns={columns}
          service={maintenanceService}
          getMethod={maintenanceService.getClosed}
          refresh={datagridRefresh}
          disableDelete
        />
      </TenantPage>
    </>
  );
};

export default ArchivedMaintenances;
